import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

interface RelatedArticlesProps {
  currentSlug: string;
  category: string;
  articles: Article[];
}

export default function RelatedArticles({
  currentSlug,
  category,
  articles,
}: RelatedArticlesProps) {
  const related = articles
    .filter((a) => a.slug !== currentSlug)
    .filter((a) => a.category === category)
    .slice(0, 2);

  if (related.length === 0) {
    const otherCategory = articles
      .filter((a) => a.slug !== currentSlug)
      .slice(0, 2);
    if (otherCategory.length === 0) return null;
    return (
      <section className="mt-12 pt-8 border-t border-background-200/70">
        <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-6">
          推荐阅读
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {otherCategory.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </section>
    );
  }

  return (
    <section className="mt-12 pt-8 border-t border-background-200/70">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
          相关文章
        </h3>
        <Link
          to={`/category/${category}`}
          className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
        >
          查看更多
          <i className="ri-arrow-right-line ml-1"></i>
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {related.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}